<div class="mainWrap">
    <div class="bgImageWrap">
        <img src="../../../../assets/images/clientsBg.png">
    </div>
    <div class="bgImageMobileWrap">
        <img src="../../../../assets/images/ourClientHomeMobileBg.png">
    </div>
    
    <div class="bodyWrap">
        <div class="mainContainer">
            <div class="headingWrap">
                Our Clients
            </div>
            <div class="allIconsWrap">
                <div class="rowWrap" *ngFor="let i of clients">
                    <img src="{{i.iconUrl}}">
                </div>
            </div>
        </div>
    </div>
</div>